import { useState, useEffect } from 'react';
import { Translations } from '../../i18next';
export var useI18NextInstance = function (_a) {
    var language = _a.language, defaultTranslations = _a.defaultTranslations, translationsConfig = _a.translationsConfig, localeDistPath = _a.localeDistPath, initI18n = _a.initI18n;
    var initTranslations = function () {
        if ((translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.enabled) === false) {
            return undefined;
        }
        var translations = new Translations({
            language: language,
            defaultTranslations: defaultTranslations,
            availableLanguages: translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.availableLanguages,
            prefix: translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.prefix,
            localeDistPath: localeDistPath,
            initI18n: initI18n,
        });
        translations.init();
        return translations.i18n;
    };
    var _b = useState(), i18NextInstance = _b[0], setI18NextInstance = _b[1];
    useEffect(function () {
        setI18NextInstance(initTranslations());
    }, [language]);
    return i18NextInstance;
};
//# sourceMappingURL=useI18NextInstance.js.map